module.exports = __webpack_public_path__ + "static/media/top-nfts-4.b93a246f.jpg";